import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { remSize } from '../../../theme';

const NotFoundMain = styled.main`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${remSize(12)};
  text-align: center;
  padding: ${remSize(20)};
`;

// Catch-all for unknown URLs, so a typo or a removed route shows a real page instead of a blank
// App shell. i18n keys fall back to the literal string when absent, so this works without new locale
// entries.
const NotFound = () => {
  const { t } = useTranslation();
  return (
    <NotFoundMain>
      <Helmet>
        <title>{t('NotFound.Title', 'Page not found')}</title>
      </Helmet>
      <h1>{t('NotFound.Heading', 'Page not found')}</h1>
      <p>
        {t(
          'NotFound.Message',
          "The page you're looking for doesn't exist or has moved."
        )}
      </p>
      <Link to="/">{t('NotFound.HomeLink', 'Go to the editor')}</Link>
    </NotFoundMain>
  );
};

export default NotFound;
